import { createGlobalStyle } from 'styled-components';

const BoxSizingStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }
`;

export default BoxSizingStyles;
